export default __webpack_public_path__ + "static/media/dry_needling_intake.818ec81c.jpg";